var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.6383 4.10898L16.9029 0.373576C16.5761 0.0467276 16.1091 -0.0466576 15.6889 0.140113C15.2687 0.326883 14.9885 0.700424 14.9885 1.16735V3.03505H9.3854C4.48267 3.03505 0.186953 6.81716 0.046875 11.7199C0.046875 11.8133 0.046875 11.9067 0.046875 12H3.78228C3.78228 11.9067 3.78228 11.8133 3.78228 11.7199C3.96905 8.87163 6.44376 6.77046 9.29201 6.77046H14.9885V8.63817C14.9885 9.10509 15.2687 9.47863 15.6889 9.6654C16.1091 9.85217 16.5761 9.75879 16.9029 9.43194L20.6383 5.69653C21.0585 5.2763 21.0585 4.52922 20.6383 4.10898Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2181 12C20.2181 12.0934 20.2181 12.1868 20.2181 12.2802C20.0313 15.1284 17.5566 17.2296 14.7084 17.2296H9.01186V15.3619C9.01186 14.8949 8.7317 14.5214 8.31147 14.3346C7.89123 14.1479 7.42431 14.2412 7.09746 14.5681L3.36205 18.3035C2.94182 18.7237 2.94182 19.4708 3.36205 19.8911L7.09746 23.6265C7.42431 23.9533 7.89123 24.0467 8.31147 23.8599C8.7317 23.6732 9.01186 23.2996 9.01186 22.8327V20.965H14.615C19.5177 20.965 23.7667 17.1829 23.9535 12.2802C23.9535 12.1868 23.9535 12.0934 23.9535 12H20.2181Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.335006e4f694f065cae505e6c731cc37.svg";
export { ForwardRef as ReactComponent };